module.exports = __webpack_public_path__ + "static/media/new_location_icon.f7c166c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/new_location_icon.svg
// module id = 1114
// module chunks = 1